<div *ngIf="showHeaderIcon" class="header-icon-spacer"></div>
<mat-card appearance="outlined" class="step-card">
  <mat-card-header>
    <mat-card-title>
      {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.TITLE' | translate }}
    </mat-card-title>

    <mat-card-subtitle class="subtitle">
      <p *ngIf="description$ | async as description">{{ description }}</p>
    </mat-card-subtitle>
  </mat-card-header>
  <div *ngIf="loading$ | async">
    <div class="stencil-shimmer col col-xs-4 calendar-slug-shimmer"></div>
    <div class="stencil-shimmer col col-xs-4 calendar-slug-shimmer"></div>
  </div>
  <mat-card-content>
    <div *ngIf="(loading$ | async) === false">
      <div>
        <glxy-form-field [prefixText]="linkPrefix$ | async">
          <input [formControl]="slugFormControl" name="slug" />
          <button *ngIf="slugChanged$$ | async" mat-icon-button matSuffix (click)="revertSlug()">
            <mat-icon>undo</mat-icon>
          </button>
          <glxy-error *ngIf="slugFormControl.invalid">
            <ng-container
              *ngIf="slugFormControl.hasError('taken') || slugFormControl.hasError('pattern'); else genericError"
            >
              <ng-container *ngIf="slugFormControl.hasError('taken')">
                {{ slugFormControl.errors.taken }}
              </ng-container>
              <ng-container *ngIf="slugFormControl.hasError('pattern')">
                {{ slugFormControl.errors.pattern }}
              </ng-container>
            </ng-container>
            <ng-template #genericError>
              {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.VALIDATION.GENERIC_ERROR' | translate }}
            </ng-template>
          </glxy-error>
        </glxy-form-field>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div class="form-row form-actions">
      <button
        *ngIf="(isSaving$$ | async) === false"
        [disabled]="
          (loading$ | async) ||
          slugFormControl.invalid ||
          (disableButtonIfValueUnchanged && this.originalSlug === slugFormControl.value)
        "
        (click)="setSlug(slugFormControl.value)"
        mat-raised-button
        color="primary"
        type="submit"
        data-testid="slug-submit"
      >
        {{ buttonLabel }}
      </button>
      <div class="spinner-container" *ngIf="isSaving$$ | async">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
